import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicServerWhmDnsListzonesParamsRawI,
	type LWApiPublicServerWhmDnsListzonesResultsRawI,
} from '@liquidweb-dev/club-sauce/public/server/whm/dns/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const SERVER_WHM_DNS_LISTZONES_QUERY_KEY = '/server/whm/dns/listzones';

const useServerWhmDnsListzones = (
	params: LWApiPublicServerWhmDnsListzonesParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicServerWhmDnsListzonesResultsRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [SERVER_WHM_DNS_LISTZONES_QUERY_KEY, params],
		queryFn: () => api.server.whm.dns.apiRaw.listzones(params),
		...options,
	});

export default useServerWhmDnsListzones;
